<template>
  <div class="ui blue segment">
    <div class="container bootdey" id="receipt_print">
      <div class="row invoice row-printable">
        <div class="col-md">
          <!-- col-lg-12 start here -->
          <div class="panel panel-default plain" id="dash_0">
            <!-- Start .panel -->
            <div class="panel-body p30">
              <div class="row">
                <!-- Start .row -->
                <div class="col-lg-6">
                  <!-- col-lg-6 start here -->
                  <div class="invoice-logo">
                    <img
                      width="100"
                      src="/images/icons/void.jpeg"
                      alt="Invoice logo"
                    />
                  </div>
                </div>
                <!-- col-lg-6 end here -->
                <div class="col-lg-6">
                  <!-- col-lg-6 start here -->
                  <div
                    class="ui icon right floated orange icon labeled button"
                    @click="print"
                  >
                    <i class="print icon"></i> {{ $t("print") }}
                  </div>
                </div>
                <!-- col-lg-6 end here -->
                <div class="col-lg-12" style="margin-top: 10px">
                  <!-- col-lg-12 start here -->
                  <div class="invoice-details mt25">
                    <div class="well">
                      <ul class="list-unstyled mb0">
                        <li>
                          <strong>{{ $t("void receipt key") }}</strong>
                          {{ dataIn.uuid }}
                        </li>
                        <li>
                          <strong>{{ $t("voided receipt key") }}</strong>
                          {{ transaction.uuid }}
                        </li>
                        <li>
                          <strong>{{ $t("date") }}</strong>
                          {{
                            dataIn.create_date
                              | formatDate("DD/MM/YYYY HH:mm:ss")
                          }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="invoice-items">
                    <div
                      class="table-responsive"
                      style="overflow: hidden; outline: none;"
                      tabindex="0"
                    >
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th class="per70 text-center" colspan="2">
                              {{ $t("description") }}
                            </th>
                            <th class="per30 text-center">{{ $t("total") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="2">
                              {{ $t("void credit card payment") }}
                            </td>
                            <td class="text-center">
                              -
                              {{
                                transaction.request_data &&
                                transaction.request_data.amount
                                  ? transaction.request_data.amount
                                  : "" | formatVisaCurrency
                              }}
                            </td>
                          </tr>
                          <tr>
                            <th>{{ $t("audit number") }}</th>
                            <th>{{ $t("reference number") }}</th>
                            <th>{{ $t("authorization number") }}</th>
                          </tr>
                          <tr>
                            <td>
                              {{
                                dataIn &&
                                dataIn.response_data &&
                                dataIn.response_data.result &&
                                dataIn.response_data.result.response
                                  ? dataIn.response_data.result.response
                                      .auditNumber
                                  : ""
                              }}
                            </td>
                            <td>
                              {{
                                dataIn &&
                                dataIn.response_data &&
                                dataIn.response_data.result &&
                                dataIn.response_data.result.response
                                  ? dataIn.response_data.result.response
                                      .referenceNumber
                                  : ""
                              }}
                            </td>
                            <td>
                              {{
                                dataIn &&
                                dataIn.response_data &&
                                dataIn.response_data.result &&
                                dataIn.response_data.result.response
                                  ? dataIn.response_data.result.response
                                      .authorizationNumber
                                  : ""
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="ui list">
                      <div class="item">
                        <strong>VisaNet Guatemala, C.A.</strong>
                      </div>
                      <div class="item">
                        <strong>Afiliación</strong>
                        {{ dataIn.request_data.merchant }}
                      </div>
                      <!-- <div class="item">
                        <strong>Nombre de tarjeta</strong>
                        {{ requestData.card_name }}
                      </div> -->
                      <div class="item">
                        <strong>Comprobante de Anulación Pago:</strong>
                      </div>
                      <div class="item">
                        <strong>Número de tarjeta</strong>
                        {{ transaction.request_data.pan }}
                      </div>
                      <div
                        class="item"
                        v-if="requestData.quotas && requestData.quotas > 1"
                      >
                        <strong>VisaCuotas: {{ requestData.quotas }}</strong>
                      </div>
                    </div>
                  </div>
                  <!-- <pre> {{ dataIn }} </pre> -->
                </div>
                <!-- col-lg-12 end here -->
              </div>
              <!-- End .row -->
            </div>
          </div>
          <!-- End .panel -->
        </div>
        <!-- col-lg-12 end here -->
      </div>
    </div>
  </div>
</template>

<script>
import filters from "@/filters";
import { cloneDeep } from "lodash";
// import moment from "moment";
import PHE from "print-html-element";
// import { padStart } from "lodash";

let _filters = cloneDeep(filters);

export default {
  name: "VisaPaymentTransactionModalVoidInvoice",
  filters: _filters,
  props: { dataIn: Object, requestData: Object, transaction: Object },
  data() {
    return {};
  },
  computed: {},
  methods: {
    print() {
      PHE.printElement(document.getElementById("receipt_print"));
    },
  },
};
</script>

<style scoped src="@/assets/bootstrap.min.css"></style>
